export * from "@fortawesome/pro-regular-svg-icons";
